export default __webpack_public_path__ + "static/media/gatsby.18d7858f.png";